import HelpModule from './helpContainer';
import HelpMobileModule from './helpContainer.mobile'
import {isMobile} from 'Utils/device';
import './help.scss'

const HelpModuleFn = isMobile ? HelpMobileModule : HelpModule;

export default HelpModuleFn;
